import { MenuItem } from './MenuItem'
import { MenuInnerWithSub } from './MenuInnerWithSub'
// import {MegaMenu} from './MegaMenu'
import { useIntl } from 'react-intl'
import { useAuth } from '../../../../app/modules/auth'

export function MenuInner() {
	const intl = useIntl()

	const { currentUser } = useAuth()

	var permissions = [] as Array<string>;
	var permissionEle;

	setTimeout(function () {
		const link = document.getElementById('master_module_menus');

		link && currentUser?.user?.permissions?.map((permission) => {

			if (permission.name) {

				permissions = [...permissions, permission.name];
				permissionEle = link.children.namedItem(permission.name);
				if (permissionEle) {
					permissionEle.className = "col-lg-4 border-left-lg-1";

				}


			}
		})
	}, 2000);

	const authUser = currentUser?.user;
	let routeElements;

	if (authUser && authUser.roles && authUser.roles.length > 0) {
		const slugs = authUser.roles[0].slug;
		if (slugs === 'VisaExecutive' || slugs === 'VisaFileTeam') {
			routeElements = (
				<MenuItem title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} to='/visadashboard' />
			);
		}
		else if (slugs != 'Client') {
			routeElements = (
				<MenuItem title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} to='/dashboard' />
			);
		}

	}


	return (
		<>
			{routeElements}
			{/*<MenuItem title='Layout Builder' to='/builder' />*/}
			{/*<MenuInnerWithSub title='Crafted' to='/crafted' menuPlacement='bottom-start' menuTrigger='click'>
				<MenuInnerWithSub title='Pages' to='/crafted/pages' icon='/media/icons/duotune/general/gen022.svg' hasArrow={true} menuPlacement='right-start' menuTrigger={`{default:'click', lg: 'hover'}`} >					
					<MenuInnerWithSub title='Profile' to='/crafted/pages/profile' hasArrow={true} hasBullet={true} menuPlacement='right-start' menuTrigger={`{default:'click', lg: 'hover'}`} >
						<MenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
						<MenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
						<MenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
						<MenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
						<MenuItem to='/crafted/pages/profile/connections' title='Connections' hasBullet={true} />
					</MenuInnerWithSub>
					<MenuInnerWithSub title='Wizards' to='/crafted/pages/wizards' hasArrow={true} hasBullet={true} menuPlacement='right-start' menuTrigger={`{default:'click', lg: 'hover'}`} >
						<MenuItem to='/crafted/pages/wizards/horizontal' title='Horizontal' hasBullet={true} />
						<MenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
					</MenuInnerWithSub>
				</MenuInnerWithSub>
				
				<MenuInnerWithSub title='Accounts' to='/crafted/accounts' icon='/media/icons/duotune/communication/com006.svg' hasArrow={true} menuPlacement='right-start' menuTrigger={`{default:'click', lg: 'hover'}`} >					
					<MenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
					<MenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
				</MenuInnerWithSub>
				
				<MenuInnerWithSub title='Errors' to='/error' icon='/media/icons/duotune/technology/teh004.svg' hasArrow={true} menuPlacement='right-start' menuTrigger={`{default:'click', lg: 'hover'}`} >					
					<MenuItem to='/error/404' title='Error 404' hasBullet={true} />
					<MenuItem to='/error/500' title='Error 500' hasBullet={true} />
				</MenuInnerWithSub>
				
				<MenuInnerWithSub title='Widgets' to='/crafted/widgets' icon='/media/icons/duotune/general/gen025.svg' hasArrow={true} menuPlacement='right-start' menuTrigger={`{default:'click', lg: 'hover'}`} >					
					<MenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
					<MenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
					<MenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
					<MenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
					<MenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
					<MenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
				</MenuInnerWithSub>
			</MenuInnerWithSub> */}
			{(authUser && authUser.roles && authUser.roles.length > 0) &&
				(authUser.roles[0].slug != 'Client' && authUser.roles[0].slug != 'Vendor' && authUser.roles[0].slug != 'Partner' && authUser.roles[0].slug != 'VisaExecutive' && authUser.roles[0].slug != 'SalesTeam' && authUser.roles[0].slug != 'VisaFileTeam') &&
				<MenuInnerWithSub isMega={true} title='Masters' to='/mega-menu' menuPlacement='bottom-start' menuTrigger='click' >
					<div className='row' data-kt-menu-dismiss='true' id="master_module_menus">
						{/*<div className='col-lg-4 border-left-lg-1'>
						<div className='menu-inline menu-column menu-active-bg'>
							<div className='menu-item'>
								<MenuItem icon='/media/icons/duotune/general/gen051.svg' to='/area-management/list' title='Area management' />
							</div>
						</div>
					</div>*/}

						<div className='col-lg-4 border-left-lg-1 d-none ' id='campus create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/campuse-management/list'
										title='Campus management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='country create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/country-management/list'
										title='Country management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='city create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/city-management/list'
										title='City management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='course create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/course-management/list'
										title='Course management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='document category create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/documentcategory-management/list'
										title='Document Category management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='document type create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/documenttype-management/list'
										title='Document Type management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='education stream create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/educationstream-management/list'
										title='Education stream management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='education credential create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/educationcredential-management/list'
										title='Education credential management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='degree create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/educationdegree-management/list'
										title='Education Degree management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='file stage create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/filestage-management/list'
										title='File stage management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='file status create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/filestatus-management/list'
										title='File status management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='follow up method create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/followupmethod-management/list'
										title='Follow Up Method management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='institute create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/institute-management/list'
										title='Institute management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='inquiry source create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/inquirysource-management/list'
										title='Inquiry source management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='inquiry type create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/inquirytype-management/list'
										title='Inquiry type management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='inquiry status create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/inquirystatus-management/list'
										title='Inquiry status management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='inquiry subsource create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/inquirysubsource-management/list'
										title='Inquiry subsource management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='language create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/language-management/list'
										title='Language management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='marital status create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/maritalstatus-management/list'
										title='Marital status management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='networth range create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/networthrange-management/list'
										title='Networth range management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='noc create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/noc-management/list'
										title='Noc management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='organization type create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/organizationtype-management/list'
										title='Organization type management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='point field create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/pointfield-management/list'
										title='Point Field management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='profession create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/profession-management/list'
										title='Profession management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='product create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/product-management/list'
										title='Product management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='product category create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/productcategory-management/list'
										title='Product Category management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='product attribute create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/productattribute-management/list'
										title='Product Attribute management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='role create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/role-management/list'
										title='Role management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='relationship create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/relationship-management/list'
										title='Relationship management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='residence status create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/residencestatus-management/list'
										title='Residence Status management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='state create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/state-management/list'
										title='State management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='task type create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/tasktype-management/list'
										title='Task type management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='task status create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/taskstatus-management/list'
										title='Task Status management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 d-none' id='user create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/apps/user-management/list'
										title='User management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 ' id='user create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/notification-management/list'
										title='Notification management'
									/>
								</div>
							</div>
						</div>

						<div className='col-lg-4 border-left-lg-1 ' id='user create'>
							<div className='menu-inline menu-column menu-active-bg'>
								<div className='menu-item'>
									<MenuItem
										icon='/media/icons/duotune/general/gen051.svg'
										to='/emaildocument-management/list'
										title='Email Document management'
									/>
								</div>
							</div>
						</div>
					</div>

				</MenuInnerWithSub>
			}

			{
				(authUser && authUser.roles && authUser.roles.length > 0) &&
				(authUser.roles[0].slug != 'Client' &&
					<>
						<MenuItem to='/inquiry-management/list' title='Inquiry' />
					</>
				)
			}

			{
				(authUser && authUser.roles && authUser.roles.length > 0) &&
				(authUser.roles[0].slug != 'Client' ?
					<>
						<MenuItem to='/visafile-management/list' title='Visa file' />
					</>
					:
					<>
						<MenuItem to={`/visafile-management/edit/${authUser.id}`} title='Visa file' />
					</>
				)
			}

			{/* <MenuItem to='/visafile-management/list' title='Visa file' /> */}



			{
				(authUser && authUser.roles && authUser.roles.length > 0) &&
				(authUser.roles[0].slug != 'Client' &&
					<>
						<MenuItem to='/clientfollowupdetail-management/list' title='Followup' />
					</>
				)
			}


			{(authUser && authUser.roles && authUser.roles.length > 0) &&
				(authUser.roles[0].slug != 'Client' && authUser.roles[0].slug != 'Vendor' && authUser.roles[0].slug != 'Partner') &&

				<>
					<MenuItem to='/task-management/list' title='Task management' />
					<MenuItem to='/report-management/list' title='Report' />
					{(authUser && authUser.roles && authUser.roles.length > 0) &&
						(authUser.roles[0].slug != 'VisaExecutive' && authUser.roles[0].slug != 'SalesTeam' && authUser.roles[0].slug != 'VisaFileTeam') &&
						<MenuItem to='/campuscourse-management/list' title='Course' />
					}

					{
						(authUser.roles[0].slug != 'SalesTeam') &&
						<MenuItem to='/clientfilechecklist-management/list' title='File check' />
					}

				</>
			}

			<MenuItem to='/usercourse-management/list' title='User Courses' />




			{/* {(authUser && authUser.roles && authUser.roles.length > 0) &&
				(authUser.roles[0].slug != 'Client' && authUser.roles[0].slug != 'Vendor' && authUser.roles[0].slug != 'Partner') &&

				<>
					{(authUser && authUser.roles && authUser.roles.length > 0) &&
						(authUser.roles[0].slug != 'VisaExecutive' && authUser.roles[0].slug != 'SalesTeam' && authUser.roles[0].slug != 'VisaFileTeam') &&
					}

				</>
			} */}




			{/*<MenuInnerWithSub isMega={true} title='Mega menu' to='/mega-menu' menuPlacement='bottom-start' menuTrigger='click' >
				<MegaMenu />
			</MenuInnerWithSub>*/}
		</>
	)
}
